import {appStore} from "../store/AppModule";

export default function(value: string, currencyCode: string): string {
    const numberValue = parseFloat(value);
    let minFractionDigits = 0;

    if (isNaN(numberValue)) {
        return value;
    }

    if (!Number.isInteger(numberValue)) {
        minFractionDigits = 2;
    }

    if (typeof(currencyCode) !== "undefined") {
         return numberValue.toLocaleString(appStore.state.culture, { style: "currency", currency: currencyCode, minimumFractionDigits: minFractionDigits });
    } else {
        return numberValue.toLocaleString(appStore.state.culture, {minimumFractionDigits: minFractionDigits});
    }
}
